import { router } from "@inertiajs/react";
import { Tabs, TabsList, TabsTrigger } from "@/sprout/tabs";
import useTranslation from "@hooks/use_translation.ts";

export type JobsTab = "search" | "saved" | "alerts";

const TAB_PATHS: Record<JobsTab, string> = {
  search: "/jobs/search",
  saved: "/jobs/saved",
  alerts: "/jobs/alerts",
};

type Props = {
  active: JobsTab;
  savedJobsEnabled?: boolean;
};

export const JobsTabs = ({ active, savedJobsEnabled }: Props) => {
  const { t } = useTranslation("jobSearch");

  return (
    <div className="max-w-[1550px] mx-auto px-6 mb-6">
      <Tabs
        value={active}
        onValueChange={(tab) =>
          router.visit(`${TAB_PATHS[tab as JobsTab]}${window.location.search}`, {
            headers: { "X-Job-Search": "true" },
          })
        }
      >
        <TabsList>
          <TabsTrigger value="search">{t("tabs.jobSearch")}</TabsTrigger>
          {savedJobsEnabled && <TabsTrigger value="saved">{t("tabs.savedJobs")}</TabsTrigger>}
          <TabsTrigger value="alerts">{t("tabs.jobAlerts")}</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
